import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { notify } from '@/ui/snackbar/notify';
import { editMyAccount } from '@/api/v4/account.api';

export const useEditAccount = () => {
  const { t } = useTranslation('default');

  const mutation = useMutation({
    mutationFn: editMyAccount,
    onError: () => {
      notify({
        message: t('unknownError'),
      });
    },
  });

  return {
    editAccount: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
};
